import _typeof from "/Users/songzhou/Desktop/contact-form/node_modules/@babel/runtime/helpers/esm/typeof.js";
// Copyright 2017-2022 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { BigInt } from '@polkadot/x-bigint';
export var hasBigInt = typeof BigInt === 'function' && typeof BigInt.asIntN === 'function';
export var hasBuffer = typeof Buffer !== 'undefined';
export var hasCjs = typeof require === 'function' && typeof module !== 'undefined';
export var hasDirname = typeof __dirname !== 'undefined';
export var hasEsm = !hasCjs;
export var hasProcess = (typeof process === "undefined" ? "undefined" : _typeof(process)) === 'object';
export var hasWasm = typeof WebAssembly !== 'undefined';